// extracted by mini-css-extract-plugin
export default {"disableDropdownToggleIcon":"nyD2BAdll-vC3Gse_bmCZ"};